import { _ as __rest } from '../tslib.es6-c563c1dd.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material/styles';
import { Grid, Typography } from '@mui/material';
import { DatePicker } from './DatePicker.js';
import 'date-fns/locale/pt-BR';
import '@mui/x-date-pickers/AdapterDateFns';
import '@mui/x-date-pickers/LocalizationProvider';
import '@mui/x-date-pickers/DatePicker';

const PREFIX = 'DateRange';
const classes = {
    checkContainer: `${PREFIX}-checkContainer`,
    dataSeparator: `${PREFIX}-dataSeparator`,
};
const StyledGrid = styled(Grid)(() => ({
    [`& .${classes.checkContainer}`]: {
        minHeight: '100%',
    },
    [`& .${classes.dataSeparator}`]: {
        textAlign: 'center',
    },
}));
const DateRange = (_a) => {
    var { label, initial, final, initialName, finalName, onChange } = _a, rest = __rest(_a, ["label", "initial", "final", "initialName", "finalName", "onChange"]);
    return (jsxs(StyledGrid, Object.assign({ container: true, alignItems: "center", justifyContent: "space-between" }, rest, { children: [jsx(Grid, Object.assign({ item: true, lg: 5, md: 5, xs: 5 }, { children: jsx(DatePicker, { label: label, value: initial, name: initialName, handleChange: onChange }) })), jsx(Grid, Object.assign({ item: true, lg: 2, md: 2, xs: 2, className: classes.dataSeparator }, { children: jsx(Typography, Object.assign({ variant: "body1", component: "span" }, { children: "a" })) })), jsx(Grid, Object.assign({ item: true, lg: 5, md: 5, xs: 5 }, { children: jsx(DatePicker, { label: label, value: final, name: finalName, handleChange: onChange }) }))] })));
};

export { DateRange };
